import { HashMap } from "../../shared/model/HashMap";

export class ConfirmDeleteDialogState {
    constructor(
        public showConfirmDelete = false,
        public blockDelete = false,
        public modalWarningLabel: string = "",
        public processesToDelete: IProcessIdWithName[] = [],
        public warnings: IWarning = {}) {
    }
}

export interface IWarning {
    [processName: string]:
    {
        [processVersion: string]: string[]
    };
}

export interface IProcessIdWithName {
    id: number;
    name: string;
}